var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col p-2 bg-gray-800"},_vm._l((_vm.enabledLanes),function(lane,index){return _c('Lane',{key:index,attrs:{"lane":lane,"offset":index},on:{"play-note":_vm.playNote,"toggle-note":_vm.toggleNote}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }